var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"productNotFound",attrs:{"id":"productNotFound"}},[_c('not-found'),_c('protect-now')],1)}
var staticRenderFns = []

export { render, staticRenderFns }